var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header'),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_c('div',{staticStyle:{"height":"200px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }